var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossLimitFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 20.5a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5h18.5zM16 2a1 1 0 011 1v8c0 .138.112.25.25.25h1.967c.937 0 1.359 1.175.636 1.771l-7.216 5.954c-.37.304-.904.304-1.274 0L4.147 13.02c-.723-.596-.301-1.77.636-1.771H6.75A.25.25 0 007 11V3a1 1 0 011-1h8z",
    fill: "currentColor"
  })));
}
SvgLossLimitFilled.displayName = 'LossLimitFilled';
export default SvgLossLimitFilled;